import React from 'react';
import styled from '@emotion/styled';

import Timeline from './timeline';

const Component: React.FCX = ({ className }) => (
  <div className={className}>
    <Timeline />
  </div>
);

const StyledComponent = styled(Component)`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  padding: 0 6em;
  color: var(--color-text-inverse);
`;

export default StyledComponent;
